import { Link } from 'react-router-dom';

import logo from '../../assets/images/fn-logo-sm.png'

import styles from './Logo.module.css';

const Logo = () => {

	return(
		<Link to={'/'} className={styles.Link}>
			<div>
				<h3 className={styles.Name}>PoliticalPredictions</h3>
				<div className="d-flex align-items-center"> 
					<p className={styles.Brand}>Powered by</p>
					<img src={logo} alt='FiscalNote' className={styles.FNLogo} />
				</div>
			</div>
		</Link>
	)

}

export default Logo